import React from 'react';
import i18next from 'i18next';

import { OtoButtons } from 'app/components/common';
import { Tenants } from 'enums';

import type { TOriginalRestaurantWithMaybeFinancialConfig } from 'types';

type RestaurantFinancialSettingsProps = {
  onEditOrdersCommissionClick: (tenantName: Tenants) => void;
  onEditOnlinePaymentsCommissionClick: (tenantName: Tenants) => void;
  onCreateFinancialConfigClick?: () => void;
  onAddTenantOrdersConfigClick?: () => void;
  onRemoveTenantConfigClick?: (tenantName: Tenants) => void;
  restaurant: TOriginalRestaurantWithMaybeFinancialConfig;
};

const RestaurantFinancialSettings: React.FC<
  RestaurantFinancialSettingsProps
> = ({
  onEditOrdersCommissionClick,
  onEditOnlinePaymentsCommissionClick,
  onCreateFinancialConfigClick,
  onAddTenantOrdersConfigClick,
  onRemoveTenantConfigClick,
  restaurant,
}) => {
  
  const addFinancialConfigButton = onCreateFinancialConfigClick && (
    <OtoButtons.AddButton onClick={onCreateFinancialConfigClick}>
      Dodaj ustawienia finansowe
    </OtoButtons.AddButton>
  );

  if (!restaurant.finance_settings) {
    return (
      <div className="align-vertical">
        <span>Brak ustawień finansowych</span>
        {addFinancialConfigButton}
      </div>
    );
  }

  return (
    <div style={{ marginBottom: '10px' }}>
      <div>Prowizje od zamówień:</div>
      {!!restaurant.finance_settings.orders?.commission ? (
        <>
          {Object.entries(restaurant.finance_settings.orders.commission).map(
            ([tenantName, tenantCommission]) => (
              <div key={tenantName} className="align-vertical" style={{ marginBottom: '8px' }}>
                <span>
                  {tenantName}: {tenantCommission?.orders}% prowizji podstawowej
                </span>
                <OtoButtons.EditButton
                  onClick={() =>
                    onEditOrdersCommissionClick(tenantName as Tenants)
                  }
                >
                  {i18next.t('Change')}
                </OtoButtons.EditButton>
                <span>
                  + {tenantCommission?.online_payments}% za płatności online
                </span>
                <OtoButtons.EditButton
                  onClick={() =>
                    onEditOnlinePaymentsCommissionClick(tenantName as Tenants)
                  }
                >
                  {i18next.t('Change')}
                </OtoButtons.EditButton>
                {onRemoveTenantConfigClick && (
                  <OtoButtons.DeleteButton
                    onClick={() =>
                      onRemoveTenantConfigClick(tenantName as Tenants)
                    }
                    outline
                  >
                    Usuń
                  </OtoButtons.DeleteButton>
                )}
              </div>
            )
          )}
          {onAddTenantOrdersConfigClick && (
            <div className="align-vertical" style={{ marginTop: '8px' }}>
              <OtoButtons.AddButton onClick={onAddTenantOrdersConfigClick}>
                Dodaj platformę
              </OtoButtons.AddButton>
            </div>
          )}
        </>
      ) : (
        <div className="align-vertical">
          <span>Brak ustawień prowizji</span>
          {addFinancialConfigButton}
        </div>
      )}
    </div>
  );
};

export default RestaurantFinancialSettings;
